export default "/assets/images/hi-mila-black.8c5a7edbfb880b48.png";